import Vue from 'vue'
import iban from 'iban'

Vue.filter('iban', function (value) {
  if (!value) return ''
  return iban.printFormat(value)
})
